import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import whatsappIcon from '../images/whatsapp.png';

const Layout = ({children}) => {
  
  return (
    <div className="App">
      <Header />
      {children}
      <Footer />
      <a
      href="https://wa.me/+923210523339" 
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center p-3 bg-white rounded-full shadow-lg"
    >
      <img src={whatsappIcon} alt="WhatsApp" className="w-12 h-12" />
    </a>
    </div>
  );
};

export default Layout;
